export default __webpack_public_path__ + "static/461-717e7034ba31961df0457c412c178cef.gif";